import React, { useEffect, useState } from "react";
import axios from 'axios';
import { Box, TextField, Typography, List, ListItem, ListItemText, IconButton, Menu, MenuItem, Checkbox, Modal } from "@mui/material";
import Carousel from 'react-material-ui-carousel';
import InventoryIcon      from '@mui/icons-material/Inventory';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import LocalShippingIcon  from '@mui/icons-material/LocalShipping';
import CheckCircleIcon    from '@mui/icons-material/CheckCircle';
import ReplayIcon         from '@mui/icons-material/Replay';
import ReportProblemIcon  from '@mui/icons-material/ReportProblem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CircleIcon from "@mui/icons-material/Circle";
import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
  } from "@mui/material";
  import { 
    FaClipboardList,    // total
    FaCheckCircle,      // entregado
    FaTimesCircle,      // rechazado
    FaBan,              // cancelado
    FaMoneyBillWave,    // ingreso
    FaPiggyBank,        // depósito
    FaBalanceScale,
    FaEye
  } from 'react-icons/fa';

  import LinearProgress from "@mui/material/LinearProgress";
  import { useTheme } from "@mui/material/styles";

const ResumenAdmin = ({ onBackClick }) => {
    const [deliveryPoints, setDeliveryPoints] = useState([]);
    const [orders, setOrders] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [selectedDeliveries, setSelectedDeliveries] = useState([]);
    const [images, setImages] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const [totalOrder, setTotalOrder] = useState(0);
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentOrderId, setCurrentOrderId] = useState(null);
    const theme = useTheme();

    const [checkboxState, setCheckboxState] = useState({
        quinceSoles: {}, // for the quince_soles checkboxes
        veinteSoles: {} // for the veinte_soles checkboxes
    });

    // Accounting variables:
    const totalCount    = deliveryPoints.length;
    const deliveredCount = deliveryPoints.filter(dp => dp.status === "entregado").length;
    const canceledCount  = deliveryPoints.filter(dp => dp.status === "cancelado").length;
    const rejectedCount  = deliveryPoints.filter(dp => dp.status === "rechazado").length;
    // Accounting variables for each user
    const totalSel = selectedDeliveries.length;
    const entregadas = selectedDeliveries.filter(dp => dp.status === 'entregado').length;
    const rechazadas = selectedDeliveries.filter(dp => dp.status === 'rechazado').length;
    const canceladas = selectedDeliveries.filter(dp => dp.status === 'cancelado').length;

    const [totalDay, setTotalDay] = useState(0);
    const [totalDeposit, setTotalDeposit] = useState(0);

    
    const statusMap = {
        pending:    { value: 10,  color: theme.palette.warning.main },
        encamino:   { value: 50,  color: theme.palette.info.main    },
        entregado:  { value: 100, color: theme.palette.success.main },
        cancelado:  { value: 0,   color: theme.palette.error.main   },
        rechazado: { value: 100, color: theme.palette.error.main   },
    };

    const statusIconMap = {
        in_warehouse:   <InventoryIcon      titleAccess="In Warehouse"      />,
        in_fastmax:     <CheckCircleIcon    titleAccess="In FastMax"         color="success" />,
        out_for_delivery: <AirportShuttleIcon titleAccess="Out for Delivery"        />,
        delivered:      <LocalShippingIcon titleAccess="Delivered" />,
        returned:       <ReplayIcon         titleAccess="Returned"          color="action"  />,
        lost_or_damaged:<ReportProblemIcon titleAccess="Lost or Damaged"  color="error"   />,
    };
    

    useEffect(() => {
        const fetchResumenData = async () => {
            if (!selectedDate) return;
    
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/resumen_data/admin`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                    params: { date: selectedDate }
                });
                console.log("Fetched Resumen Data:", response.data);
                setOrders(response.data.recojos);
                setDeliveryPoints(response.data.entregas);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };
    
        fetchResumenData();
    }, [selectedDate, currentOrderId]);

    useEffect(() => {
        // Initialize checkbox state for each type (quince_soles, and veinte_soles)
        
        const initialQuinceSolesState = deliveryPoints.reduce((acc, point) => {
            acc[point.id] = point.quince_soles || false;
            return acc;
        }, {});
    
        const initialVeinteSolesState = deliveryPoints.reduce((acc, point) => {
            acc[point.id] = point.veinte_soles || false;
            return acc;
        }, {});
    
        setCheckboxState({
            quinceSoles: initialQuinceSolesState,
            veinteSoles: initialVeinteSolesState
        });
    }, [deliveryPoints]);

    
    const handleCheckboxQuinceClick = (deliveryPointId, isChecked) => {
        setCheckboxState(prevState => ({
            ...prevState,
            quinceSoles: { ...prevState.quinceSoles, [deliveryPointId]: isChecked }
        }));
    
        axios.post(`${process.env.REACT_APP_API_URL}/api/update_quince_soles`, {
            id: deliveryPointId,
            quince_soles: isChecked
        })
        .then(response => {
            console.log("Updated quince_soles:", response.data);
        })
        .catch(error => {
            console.error("Error updating quince_soles:", error);
        });
    };
    
    const handleCheckboxVeinteClick = (deliveryPointId, isChecked) => {
        setCheckboxState(prevState => ({
            ...prevState,
            veinteSoles: { ...prevState.veinteSoles, [deliveryPointId]: isChecked }
        }));
    
        axios.post(`${process.env.REACT_APP_API_URL}/api/update_veinte_soles`, {
            id: deliveryPointId,
            veinte_soles: isChecked
        })
        .then(response => {
            console.log("Updated veinte_soles:", response.data);
        })
        .catch(error => {
            console.error("Error updating veinte_soles:", error);
        });
    };
    
    useEffect(() => {
        // 1️⃣ Filtramos solo los puntos 'entregado' o 'rechazado'
        const delivered = deliveryPoints.filter(
          dp => dp.status === 'entregado' || dp.status === 'rechazado'
        );
      
        // 2️⃣ Contamos cuántas entregas tiene cada usuario
        const userCounts = delivered.reduce((acc, dp) => {
          acc[dp.user_id] = (acc[dp.user_id] || 0) + 1;
          return acc;
        }, {});
      
        // 3️⃣ Definimos el set de usuarios con precio especial
        const specialUsers = new Set([167, 274, 319, 397, 398, 399, 400, 401, 402, 403, 404, 405, 408, 415, 416]);
      
        // 4️⃣ Calculamos el total
        const total = delivered.reduce((sum, dp) => {
          let price;
      
          // a) Primero: flags fijos de monto
          if (dp.veinte_soles) {
            price = 20;
          } else if (dp.quince_soles) {
            price = 15;
          }
          // b) Luego: usuarios especiales
          else if (specialUsers.has(dp.user_id)) {
            price = 7.9;
          }
          // c) Usuario no especial con UNA sola entrega
          else if (userCounts[dp.user_id] === 1) {
            price = 15;
          }
          // d) Usuario no especial con más de una entrega
          else {
            price = 9.9;
          }
      
          return sum + price;
        }, 0);
      
        // 5️⃣ Redondeamos a dos decimales y actualizamos el estado
        setTotalDay(parseFloat(total.toFixed(2)));
      }, [deliveryPoints]);

    const handleDownloadExcel = () => {
        // Define the columns you want in the Excel file
        const worksheetData = deliveryPoints.map(dp => ({
          id: dp.id,
          recipient_name: dp.recipient_name,
          user_name: dp.user_name,
          user_phone: dp.user_phone,
          address: dp.address,
          recipient_phone: dp.recipient_phone,
          district: dp.district,
          product: dp.product,
          status: dp.status,
          charge: dp.charge,
          charged: dp.charged,
          driver_id: dp.driver_id,
          notes_driver: dp.notes_driver,
          notes: dp.notes
        }));
    
        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    
        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'DeliveryPoints');
    
        // Write the Excel file and save it
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'DeliveryPoints.xlsx');
      };

      const handleOrderClick = (order) => {
        setSelectedOrder(order);
        
        // Filter delivery points associated with the selected order
        const relevantDeliveries = deliveryPoints.filter(dp => dp.user_id === order.customer_id);
        setSelectedDeliveries(relevantDeliveries);
        setImages([]);  // Clear images when selecting a new order
    
        // List of districts with a delivery price of 10 soles
        
        
        const deliveredPoints = relevantDeliveries.filter(dp => dp.status === 'entregado' || dp.status === 'rechazado');
        const numDeliveries = deliveredPoints.length;
        
        const specialPricing = {
            6: 7.9,  // For user_id 13, each delivery costs 7 soles
            1: 7.9,  // For user_id 53, each delivery costs 7 soles
            167: 7.9,
            274: 7.9, 
            319: 7.9, 
            397: 7.9, 
            398: 7.9, 
            399: 7.9, 
            400: 7.9, 
            401: 7.9, 
            402: 7.9, 
            403: 7.9, 
            404: 7.9, 
            405: 7.9, 
            408: 7.9, 
            415: 7.9, 
            416: 7.9,
        };
        
        let total = 0; 
        // Calculate total price for each delivery point
        deliveredPoints.forEach(dp => {
            let price;
          
            // 1️⃣ Primero chequeamos los montos fijos (veinte o quince soles)
            if (dp.veinte_soles) {
              price = 20;
            } else if (dp.quince_soles) {
              price = 15;
            }
            // 2️⃣ Después aplicamos precio especial por usuario (1, 6 o 7)
            else if (specialPricing[dp.user_id]) {
              price = specialPricing[dp.user_id];
            }
            // 3️⃣ Si solo hay UNA entrega y no aplica ninguno de los anteriores → 15
            else if (numDeliveries === 1) {
              price = 15;
            }
            // 4️⃣ Por último, el precio base
            else {
              price = 9.9;
            }
          
            total += price;
          });
    
        // Calculate totalDeposit based on the 'charged' field from the relevant deliveries
        const totalDeposit = deliveredPoints.reduce(
            (acc, dp) => acc + (dp.charged || 0),
            0
          );
    
        // Set the totalOrder and totalDeposit state
        setTotalOrder(parseFloat(total.toFixed(2)));
        setTotalDeposit(totalDeposit);
    };
    

    const handleDeliveryPointClick = (deliveryPoint) => {
        setImages(deliveryPoint.image_urls || []);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setImages([]);
    };

    const handleStatusChangeClick = (event, orderId) => {
        setAnchorEl(event.currentTarget);
        setCurrentOrderId(orderId);
    };

    const handleStatusChange = async (status) => {
        if (!currentOrderId) return;

        const token = localStorage.getItem("token");

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/status_change`, {
                orderId: currentOrderId,
                status: status
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            setOrders(prevOrders => prevOrders.map(order =>
                order.id === currentOrderId ? { ...order, status: status } : order
            ));
        } catch (error) {
            console.error("Error updating status:", error);
        } finally {
            setAnchorEl(null);
            setCurrentOrderId(null);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
        setCurrentOrderId(null);
    };
    
    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: 2 }}>
        
        <Box sx={{ marginBottom: 2 }}>
        <ArrowBackIcon onClick={onBackClick} style={{ color: 'black' }}/>
          <TextField
            label="Pick Date"
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginTop: 2 }}
          />
        </Box>

        <Box sx={{ display: "flex", flexGrow: 1 }}>
    <Box sx={{ width: "20%", overflowY: "auto", padding: 2, maxHeight: '700px' }}>
        <Typography variant="h6" color="text.primary">Resumen del Día</Typography>
        <Typography variant="body1" color="text.primary">Usuarios: {orders.length} Entregas:{deliveryPoints.length}</Typography>
        <Typography variant="body1" color="text.primary">
            Total: {totalCount}&nbsp;
            
            {/* Entregados */}
            <CircleIcon
            sx={{
                color: theme.palette.success.main,
                fontSize: "0.8rem",
                verticalAlign: "middle",
                mx: 0.3
            }}
            />{" "}
            {deliveredCount} &nbsp;

            {/* Cancelados */}
            <CircleIcon
            sx={{
                color: 'red',
                fontSize: "0.8rem",
                verticalAlign: "middle",
                mx: 0.3
            }}
            />{" "}
            
            {rejectedCount}
            {/* Rechazados */}
            <CircleIcon
            sx={{
                color: 'gray',  // or a custom purple
                fontSize: "0.8rem",
                verticalAlign: "middle",
                mx: 0.3
            }}
            />{" "}
            
            {canceledCount} &nbsp;
        </Typography>
        <Typography variant="body1" color="text.primary">
            Total de Ingreso: S/ {totalDay.toFixed(2)}
        </Typography>
        <FileCopyIcon onClick={handleDownloadExcel} style={{ color: 'black' }}/>
        <Typography variant="h6" sx={{ marginTop: 2 }} color="text.primary">Lista de Recojos</Typography>
        
        <List>
        {orders.map((order) => (
                <ListItem key={order.id} onClick={() => handleOrderClick(order)}>
                    <ListItemText
                        primary={`Recojo ${order.id}-${order.customer_id}: ${order.customer_name} - ${order.status}`}
                        primaryTypographyProps={{ color: "text.primary" }}
                    />
                    <IconButton
                        color="secondary"
                        onClick={(event) => handleStatusChangeClick(event, order.id)}
                    >
                        <AttachMoneyIcon />
                    </IconButton>
                </ListItem>
            ))}
        </List>
    </Box>
    <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => handleStatusChange('pagado')}>Pagado</MenuItem>
                <MenuItem onClick={() => handleStatusChange('adeuda')}>Adeuda</MenuItem>
                <MenuItem onClick={() => handleStatusChange('depositar')}>Depositar</MenuItem>
                <MenuItem onClick={() => handleStatusChange('cancelado')}>Cancelado</MenuItem>
            </Menu>

            <Box sx={{ width: "80%", overflowY: "auto", padding: 2, maxHeight: '700px' }}>
    <Typography variant="h6" color="text.primary">Usuario</Typography>
    {selectedOrder ? (
        <>
            <List>
                <ListItem>
                    <ListItemText
                        primary={
                            <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            {/* Nombre y estado */}
                            {selectedOrder.provider_id} - 
                            {selectedOrder.customer_name} — {selectedOrder.status}
                            <span style={{ margin: '0 8px' }}>|</span>

                            {/* Total de entregas */}
                            <FaClipboardList style={{ marginRight: 4 }} />
                            {totalSel}

                            {/* Entregadas */}
                            <FaCheckCircle style={{ margin: '0 4px', color: 'green' }} />
                            {entregadas}

                            {/* Rechazadas */}
                            <FaTimesCircle style={{ margin: '0 4px', color: 'red' }} />
                            {rechazadas}

                            {/* Canceladas */}
                            <FaBan style={{ margin: '0 4px', color: 'gray' }} />
                            {canceladas}

                            <span style={{ margin: '0 8px' }}>|</span>

                            {/* Ingreso */}
                            <FaMoneyBillWave style={{ marginRight: 4 }} />
                            S/ {totalOrder.toFixed(2)}

                            <span style={{ margin: '0 8px' }}>|</span>

                            {/* Depósito */}
                            <FaPiggyBank style={{ marginRight: 4 }} />
                            S/ {totalDeposit.toFixed(2)}

                            <span style={{ margin: '0 8px' }}>|</span>

                            {/* Diferencia */}
                            <FaBalanceScale style={{ marginRight: 4 }} />
                            S/ {(totalDeposit - totalOrder).toFixed(2)}
                            </span>
                        }
                        primaryTypographyProps={{ color: 'text.primary' }}
                        />
                </ListItem>
            </List>
            <Typography variant="h6" color="text.primary">Entregas Asociadas</Typography>
            <TableContainer component={Paper} elevation={3} sx={{ mt: 2 }}>
                            <Table>
                            <TableHead>
                                <TableRow>
                                <TableCell>id</TableCell>    
                                <TableCell>Nombre</TableCell>
                                <TableCell>Teléfono</TableCell>
                                <TableCell>Producto</TableCell>
                                <TableCell align="right">Cargo</TableCell>
                                <TableCell align="right">Cobrado</TableCell>
                                <TableCell align="center">Imágenes</TableCell>
                                <TableCell>Estado</TableCell>
                                </TableRow>
                            </TableHead>
            
                            <TableBody>
                                {selectedDeliveries.map((dp) => {
                                // find images for this delivery
                                const imgs = images.filter((img) => img.deliveryPointId === dp.id);
                                const count = imgs.length;
                                const { value: progress, color } =
                                    statusMap[dp.status] || { value: 0, color: theme.palette.grey[400] };
            
                                return (
                                    <TableRow key={dp.id} hover>
                                    <TableCell>{dp.id}
                                    
                                <Checkbox
                                    checked={checkboxState.quinceSoles[dp.id] || false}
                                    onChange={(e) => handleCheckboxQuinceClick(dp.id, e.target.checked)}
                                    color="primary"
                                />
                                <Checkbox
                                    checked={checkboxState.veinteSoles[dp.id] || false}
                                    onChange={(e) => handleCheckboxVeinteClick(dp.id, e.target.checked)}
                                    color="primary"
                                />
                                    {statusIconMap[dp.package_status] || null}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            maxWidth: '150px',        // or whatever fits your layout
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                    
                                        >{dp.recipient_name}</TableCell>
                                    <TableCell>{dp.recipient_phone}</TableCell>
                                    <TableCell>{dp.product}</TableCell>
                                    <TableCell align="right">{dp.charge}</TableCell>
                                    <TableCell align="right">{dp.charged}</TableCell>
            
                                    <TableCell align="center">
                                        <FaEye button onClick={() => handleDeliveryPointClick(dp)}/>
                                    </TableCell>
            
                                    <TableCell sx={{ width: 200 }}>
                                        <LinearProgress
                                        variant="determinate"
                                        value={progress}
                                        sx={{
                                            height: 10,
                                            borderRadius: 5,
                                            backgroundColor: theme.palette.grey[200],
                                            "& .MuiLinearProgress-bar": {
                                            borderRadius: 5,
                                            backgroundColor: color,
                                            },
                                        }}
                                        />
                                    </TableCell>
                                    </TableRow>
                                );
                                })}
                            </TableBody>
                            </Table>
                        </TableContainer>
        </>
    ) : (
        <Typography variant="body2" color="text.primary">
            Seleccione un usuario en el panel de la izquierda para ver los detalles.
        </Typography>
    )}
</Box>
            <Modal open={isModalOpen} onClose={handleCloseModal}>
                <Box sx={{ width: '90%', maxWidth: 600, margin: 'auto', mt: 10, bgcolor: 'white', p: 3, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Imágenes del punto de entrega</Typography>
                    <Carousel autoPlay={true} navButtonsAlwaysVisible>
                        {images.map((img, index) => (
                            <Box key={index} sx={{ textAlign: 'center' }}>
                                <img key={index} src={img} alt={`Imagen ${index + 1}`} style={{ width: '100%', maxHeight: 400, objectFit: 'contain' }} />
                            </Box>
                        ))}
                    </Carousel>
                </Box>
            </Modal>
        </Box>
      </Box>
    );
};

export default ResumenAdmin;
